import type { EventPageVisibility } from '@graphql/generated';

/**
 * Reusable utility function for checking if a page is visible
 * A page is considered visible if it's public or password protected
 * Accepts both GraphQL enum values and string literals for compatibility
 */
export const isEventPageVisible = (visibility?: EventPageVisibility | 'hidden' | 'passwordProtected' | 'public') => {
  if (!visibility) return false;
  return visibility === 'public' || visibility === 'passwordProtected';
};
